<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick" transfer>
      <!--<Avatar :src="userAvator"/>-->
      <a :style="{color: '#000'}" v-if="name">{{ $store.state.user.name }}</a>
      <a :style="{color: '#000'}" v-else>{{ $store.state.user.userName }}</a>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="changePassword">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
import config from '@/config'
export default {
  name: 'User',
  data () {
    return {
      userName: this.$store.state.user.userName,
      name: this.$store.state.user.name
    }
  },
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(res => {
            if (!config.ssoEnabled) {
              this.$router.push({
                name: 'login'
              })
            } else {
              window.location.href = config.ssoDomain + '/cas/logout?service=' + config.ssoDomain + '/cas/login?service=' + config.opsDomain
            }
            console.log('回到user.vue')
            console.log(res)
          })
          break
        case 'changePassword':
          this.$router.push({name: 'change_password'})
          break
      }
    }
  }
}
</script>
